import http from '../../utils/httpService';
import { DIPLOMA_DATA_ROUTE } from './constants';

/**
 *
 * @param data
 */
const postDiploma = data => (
    http.request( DIPLOMA_DATA_ROUTE, 'POST', data )
);
/**
 *
 * @param data
 * @param id
 */
const putDiploma = ( data, id ) => (
    http.request( DIPLOMA_DATA_ROUTE + `/${ id }`, 'PUT', data )
);
/**
 *
 * @param id
 */
const getDiploma = ( id ) => (
    http.request( DIPLOMA_DATA_ROUTE + `/${ id }`, 'GET' )
);
/**
 *
 * @param id
 */
const deleteDiploma = ( id ) => (
    http.request( DIPLOMA_DATA_ROUTE + `/${ id }`, 'DELETE' )
);

export { postDiploma, putDiploma, getDiploma, deleteDiploma };